export const EtxeApiParams = {
  // IDs
  PROPERTY_ID: 'propertyId',
  PROPERTY_APPLICATION_ID: 'propertyApplicationId',
  DISCUSSION_ID: 'discussionId',
  MESSAGE_ID: 'messageId',
  AGENT_ID: 'agentId',
} as const;
